var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter-accordion__header"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('span',[_vm._v(" "+_vm._s(_vm.disabled ? _vm.$t('filter.label_not_available') : _vm.$t('filter.label_show_all'))+" "),(!_vm.disabled)?_c('i',{class:[
        {
          'fa-solid fa-chevron-up fa-2xs': !_vm.collapsed,
          'fa-solid fa-chevron-down fa-2xs': _vm.collapsed
        }
      ]}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }